import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const effectiveDate = "January 19, 2026";

  return (
    <PageWrapper>
      <button 
        onClick={() => navigate(-1)} 
        className="back-btn"
        data-testid="back-btn"
      >
        ← Back
      </button>

      <article className="legal-page" data-testid="privacy-page">
        <h1>Privacy Policy</h1>
        <p className="effective-date"><strong>Effective Date:</strong> {effectiveDate}</p>

        <div className="legal-content">
          <p>
            Uro2Go may collect basic account information, usage analytics, and device 
            information to operate and improve the platform.
          </p>

          <p>
            Uro2Go does not collect or store medical records or protected health information 
            unless explicitly stated.
          </p>

          <p>
            Information is used solely for platform operation, security, and communication.
          </p>

          <p>
            Third-party services may be used for hosting, analytics, authentication, or video 
            delivery and are governed by their respective privacy policies.
          </p>

          <p>
            Uro2Go is not intended for children under the age of 13.
          </p>

          <p>
            This policy may be updated periodically.
          </p>

          <div className="contact-info">
            <p><strong>Contact:</strong> <a href="mailto:uro2go@gmail.com">uro2go@gmail.com</a></p>
          </div>
        </div>
      </article>
    </PageWrapper>
  );
};

export default PrivacyPage;
